import { FormikErrors } from 'formik';
import { SavedList } from '~/clientApi/savedLists.model';
import { trackEvent } from '~/core/utils/trackEvent';
import { IShareLinkMapped } from '~/shareLinkApi/shareLink.model';
import { ICreator } from '~/types';
import { isValidEmail } from '~/utils';

import { MessageTemplate, MessageToolFormValues } from './MessageToolModal';
import { MESSAGE_MAX_CHARACTERS } from './constants';

export const validate = (values: MessageToolFormValues) => {
  const errors: FormikErrors<MessageToolFormValues> = {};

  if (!values.name || values.name.trim() === '')
    errors.name = 'Name is required';
  if (!values.company || values.company.trim() === '')
    errors.company = 'Company is required';
  if (!values.email || values.email.trim() === '') {
    errors.email = 'Email is required';
  } else if (!isValidEmail(values.email))
    errors.email = 'Must be a valid email';

  if (values.message.length > MESSAGE_MAX_CHARACTERS) {
    errors.message = `Message must be less than ${MESSAGE_MAX_CHARACTERS} characters`;
  }

  return errors;
};

interface TrackMessageToolEventProps {
  eventType: string;
  creator: ICreator;
  list: SavedList;
  link: IShareLinkMapped;
  values?: MessageToolFormValues;
  template?: MessageTemplate;
}

export const trackMessageToolEvent = ({
  eventType,
  creator,
  list,
  link,
  values,
  template,
}: TrackMessageToolEventProps) => {
  const { name, email, company, message } = values || {};
  const baseProps = {
    creator_id: creator?.id || '',
    list_id: list?.id || '',
    type: list?.category || '',
    shared_link_owner_id:
      link?.owners?.find(
        (owner: { ownerType: string }) => owner.ownerType === 'manager',
      )?.ownerId || '',
    creator_manager_id: creator?.manager?.id || '',
  };

  switch (eventType) {
    case 'modal_opened':
      trackEvent('foam_shared_list_message_modal_opened', {
        ...baseProps,
      });
      break;

    case 'quick_question_clicked':
      trackEvent('foam_shared_list_message_quick_question_clicked', {
        ...baseProps,
        question_selected: template?.event_name || '',
      });
      break;

    case 'message_submitted':
      trackEvent('foam_shared_list_message_sent_successfully', {
        ...baseProps,
        marketer_name: name || '',
        marketer_email: email || '',
        marketer_company: company || '',
        message_sent: message || '',
      });
      break;
  }
};
